<template>
  <v-app-bar
    v-if="!isHide()"
    app
    clipped-left
    color="primary"
    dark
    flat
  >
    <template v-slot:img="{ }">
      <div
        class="d-flex align-end "
        style="height: 100%;display: flex;justify-content: flex-end;flex-flow: column;"
      >
        <v-img
          :style="`width:100%;background-color:${subPrimaryColor}`"
          max-height="2px"
        />
        <v-img
          :style="`width:100%;background-color:${accentColor}`"
          max-height="5px"
        />
      </div>
    </template>
    <v-toolbar-title>
      <router-link
        v-if="user"
        to="/novels"
      >
        <v-img
          class="button-logo-img mr-4 mt-4 mb-4 ml-3"
          contain
          max-width="200px"
          src="../assets/logo_top.png"
        />
      </router-link>
      <a
        v-else
        href="https://novewrite.tech/"
      >
        <v-img
          class="button-logo-img mr-4 mt-4 mb-4 ml-3"
          contain
          max-width="220px"
          src="../assets/logo_top.png"
        />
      </a>
    </v-toolbar-title>
    <v-spacer class="ml-2" />
<!--    <v-card-->
<!--        v-if="user"-->
<!--        color="transparent"-->
<!--        flat-->
<!--        to="/diary"-->
<!--    >-->
<!--      <v-card-title class="ma-0 pa-0 ">-->
<!--        <v-img-->
<!--            contain-->
<!--            max-height="20px"-->
<!--            src="../assets/w_icon_report.png"-->
<!--        />-->
<!--      </v-card-title>-->
<!--      <v-card-text-->
<!--          class="ma-0 pa-0 toolbar-item-label"-->
<!--          style="font-size: 11px ; color: white; text-align: center"-->
<!--      >-->
<!--        執筆記録-->
<!--      </v-card-text>-->
<!--    </v-card>-->
    <v-card
      v-if="user"
      class="ml-3"
      color="transparent"
      flat
      to="/setting"
    >
      <v-card-title class="ma-0 pa-0 ">
        <v-img
          contain
          max-height="20px"
          src="../assets/settei.png"
        />
      </v-card-title>
      <v-card-text
        class="ma-0 pa-0 toolbar-item-label"
        style="font-size: 11px ; color: white; text-align: center"
      >
        設定
      </v-card-text>
    </v-card>
    <v-card
      v-if="user"
      class="ml-3"
      color="transparent"
      flat
      target="_blank"
      href="https://tayori.com/form/726232b1c9bd14a9933a5eea1947e7913bf81f05"
    >
      <v-card-title class="ma-0 pa-0">
        <v-img
          contain
          max-height="20px"
          src="../assets/mail.png"
        />
      </v-card-title>
      <v-card-text
        class="ma-0 pa-0 toolbar-item-label"
        style="font-size: 11px ; color: white; text-align: center"
      >
        お問い合わせ
      </v-card-text>
    </v-card>
    <v-card
      v-if="user"
      class="ml-3 mr-0"
      color="transparent"
      flat
      @click="loguout"
    >
      <v-card-title class="ma-0 pa-0">
        <v-img
          contain
          max-height="20px"
          src="../assets/logout.png"
        />
      </v-card-title>
      <v-card-text
        class="ma-0 pa-0  toolbar-item-label"
        style="font-size: 11px ; color: white; text-align: center ;"
      >
        ログアウト
      </v-card-text>
    </v-card>

    <router-link
      v-if="user && !isPremium"
      class="pa-0 ma-0 ml-3"
      to="/input-card"
    >
      <img
        class="premium-banner"
        src="../assets/premium.png"
        style="margin-right:-20px;margin-bottom: 12px;"
      >
    </router-link>
  </v-app-bar>
</template>

<script>
import firebase from "firebase/app";
import {mapState} from "vuex";


export default {
  name: "Appbar",
  methods: {
    loguout() {
      firebase.auth().signOut().then(value => {
        this.$router.push("/login")
      });
    },
    isHide() {
      return this.$route.path.startsWith("/novels/") && this.hideAppbar
    }
  },
  computed: {
    ...mapState({
      isPremium: state => state.userModule.isPremium,
      user: state => state.userModule.user,
      hideAppbar: state => state.userModule.hideTopBottomMode
    })
  },
  data() {
    return {
      accentColor: null,
      subPrimaryColor: null,
    }
  },
  watch: {
    '$vuetify.theme.themes.light.secondary'(old, newValue) {
      this.accentColor = this.$vuetify.theme.themes.light.secondary
      const primary = this.$vuetify.theme.themes.light.primary
      const red = parseInt(primary.substring(1, 3), 16);
      const green = parseInt(primary.substring(3, 5), 16);
      const blue = parseInt(primary.substring(5, 7), 16);
      this.subPrimaryColor = "#" + (red + 37).toString(16) + (green + 24).toString(16) + (blue + 9).toString(16)
    }
  },
  mounted() {
    console.dir(firebase.auth().currentUser)
    this.accentColor = this.$vuetify.theme.themes.light.secondary
    const primary = this.$vuetify.theme.themes.light.primary
    const red = parseInt(primary.substring(1, 3), 16);
    const green = parseInt(primary.substring(3, 5), 16);
    const blue = parseInt(primary.substring(5, 7), 16);
    this.subPrimaryColor = "#" + (red + 37).toString(16) + (green + 24).toString(16) + (blue + 9).toString(16)
  }
}
</script>

<style scoped>
@media screen and (max-width: 520px) {
  .toolbar-item-label {
    display: none;
  }
}

/* 画面サイズの横幅が 768px より大きい場合に適用 */
@media screen and (min-width: 960px) {
  .premium-banner {
    display: block;
  }
}

/* 画面サイズの横幅が小さい場合に適用 */
@media screen and (max-width: 960px) {
  .premium-banner {
    display: none;
  }
}
</style>